import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { confirmAnalysesActions } from 'features/confirmAnalyses';

const useConfirmAnalyses = () => {
  const dispatch = useDispatch();
  const getConfirmAnalyses = useCallback(({ offset }) => dispatch(confirmAnalysesActions.getConfirmAnalyses({ offset })), [dispatch]);
  const getConfirmAnalysis = useCallback(({ id, cable }) => dispatch(confirmAnalysesActions.getConfirmAnalysis({ id, cable })), [dispatch]);
  const clearLocalConfirmAnalyses = useCallback(() => dispatch(confirmAnalysesActions.clearLocalConfirmAnalyses()), [dispatch]);
  const clearLocalActiveConfirmAnalysis = useCallback(() => dispatch(confirmAnalysesActions.clearLocalActiveConfirmAnalysis()), [dispatch]);

  return {
    getConfirmAnalyses,
    getConfirmAnalysis,
    clearLocalConfirmAnalyses,
    clearLocalActiveConfirmAnalysis
  };
};

export default useConfirmAnalyses;